export default class BlockBanner {
	static init() {

		let banner = document.querySelector('.banner');
		if( !banner ){
			return;
		}
		const swiper = banner.querySelector('.banner-gallery .swiper');
		if (swiper) {
			let options = {
				autoplay: {
					delay: 3000,
				},
				speed: 800,
				slidesPerView: "1",
				loop: true,
				allowTouchMove: false,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				}
			};

			new Swiper(swiper, options);
		}

		let subNavToggle = banner.querySelector('.banner-menu-toggle');
		if( subNavToggle ){
			let subNavOverlay = banner.querySelector('.banner-subnav-overlay');
			subNavToggle.addEventListener("click", () => {
				document.body.classList.toggle('banner-subnav-is-open');
			});
			subNavOverlay.addEventListener("click", () => {
				document.body.classList.remove('banner-subnav-is-open');
			});
		}

	}

}
